import { render, staticRenderFns } from "./ColumnHelp.vue?vue&type=template&id=d5a81298&scoped=true"
import script from "./ColumnHelp.vue?vue&type=script&lang=js"
export * from "./ColumnHelp.vue?vue&type=script&lang=js"
import style0 from "./ColumnHelp.vue?vue&type=style&index=0&id=d5a81298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a81298",
  null
  
)

export default component.exports